class ReconCostController {
  constructor() {
  }
}

export default ReconCostController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/reconCost/reconCost.controller.js